import { useMemo } from 'react';

/**
 * Хук для проверки, содержит ли строка математическое содержимое
 * @param text - Строка для проверки
 * @returns true, если строка содержит математическое содержимое
 */
const useIsMath = (text?: string): boolean => {
	return useMemo(() => !!text?.includes('\\(') && !!text?.includes('\\)'), [text]);
};

export default useIsMath;
